import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input,
  OnInit
} from '@angular/core';
import { NgForm } from '@angular/forms';
import {
  DataEntity,
  DisplayEntityValueDataEntity
} from 'src/app/models/data-entities';

import { DataEntityInputComponent } from '../../data-entity-input/data-entity-input.component';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';


@Component({
    selector: 'wm-display-entity-value-data-entity-input',
    templateUrl: './display-entity-value-data-entity-input.component.html',
    styleUrls: ['./display-entity-value-data-entity-input.component.css'],
    standalone: false
})
export class DisplayEntityValueDataEntityInputComponent
  extends DataEntityInputComponent
  implements OnInit {
  @Input() entity: DisplayEntityValueDataEntity;
  selectedTypeCode: any;
  dataEntity: any;
  label: string;
  showEntity = true;

  constructor(public layoutService: LayoutService,componentFactoryResolver: ComponentFactoryResolver, ref: ChangeDetectorRef, context: WorkflowContextService) {
    super(layoutService, componentFactoryResolver, ref, context);
  }
  onFormSubmit(form: NgForm) {}

  ngOnInit() {
    this.entity.evaluateLabelSource();
    this.showEntity = this.entity.evaluateVisibility();
  }
}
